module.exports = "<div class=\"widget bg-white\"> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Verjaardagen</h4> <small class=text-uppercase>Eerst volgende 10 verjaardagen</small></div> <a href=javascript:; class=widget-list-item ng-repeat=\"employee in $ctrl.employees | limitTo:10\"> <span class=\"label label-info pull-right\">{{employee.birthday | date : 'dd-MM'}}</span>{{employee.displayName}} </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard.birthday.html
// module id = 425
// module chunks = 0